
function loadImage(lazyImage){
    lazyImage.src = lazyImage.dataset.src;
    delete lazyImage.dataset.src;
}
function getActiveSlide(container){
  return container.querySelector('.slick-active');
}

export function lazyLoadImages(slick,index) {
      let previousSlide = slick.$slides[index - 1];
      let _nextSlide = slick.$slides[index + 1];
      let currentEl = slick.$slides[index];

      let images = [...currentEl.querySelectorAll('img[data-src]')];
      images.forEach( img => {
        loadImage(img);
      });
      if(previousSlide){
        let images = [...previousSlide.querySelectorAll('img[data-src]')];
        images.forEach( img => {
          loadImage(img);
        });
      }
      if(_nextSlide){
        let images = [..._nextSlide.querySelectorAll('img[data-src]')];
        images.forEach( img => {
          loadImage(img);
        });
      }
}
const lazyLoadSlickSlider = function(container=null) {
  if(container==null) return;

  let activeSlide = getActiveSlide(container[0]);
  let images = [...activeSlide.querySelectorAll('img[data-src]')];
  images.forEach( img => {
    loadImage(img);
  });
  
  $(container)
    .on('beforeChange.lazyLoad', function(event, slick, currentSlide, nextSlide) {
      lazyLoadImages(slick, nextSlide);
  });
};
const lazyLoadInfiniteScroll = function(container=document, selector = 'img[data-src]') {
    let lazyImages = [].slice.call(container.querySelectorAll(selector));
    if (("IntersectionObserver" in window) == false) {
      console.log("Load Intersection Observer");
      require('intersection-observer');
    }    

    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    }
    
    function callback(entries, observer) {
      //console.log("LazyImageObserver:",entries,"\nObserver:",observer);
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
		  if ($(lazyImage).parents('.crs-slide[data-slidenumber=1]').length == 0) {
			loadImage(lazyImage);
		  }
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    }

    let lazyImageObserver = new IntersectionObserver(callback,options);

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });


};

export {lazyLoadInfiniteScroll, lazyLoadSlickSlider}